module.exports = __webpack_public_path__ + "name=img/src/assets/story/2.jpg?1c78207da27f7c138d2c6ce430c97f48";